import request from '@/utils/request'

export function submitDoc(data) {
  return request({
    url: '/dms/doc/submit',
    method: 'post',
    data
  })
}

export function getDocInfo(docId) {
  return request({
    url: `/dms/doc/info/${docId}`,
    method: 'get'
  })
}

export function getDocShareInfo(docId) {
  return request({
    url: `/dms/doc/info/s/${docId}`,
    method: 'get'
  })
}

export function getBookButtons(bookId) {
  return request({
    url: `/dms/index/book/button/${bookId}`,
    method: 'get'
  })
}

export function getStarDocs() {
  return request({
    url: '/dms/doc/star',
    method: 'get'
  })
}

export function toggleStar(docId) {
  return request({
    url: `/dms/doc/toggleStar/${docId}`,
    method: 'post'
  })
}

export function toggleLike(docId) {
  return request({
    url: `/dms/doc/toggleLike/${docId}`,
    method: 'post'
  })
}

export function getDocHistoryPage(params) {
  return request({
    url: '/dms/docHistory/page',
    method: 'get',
    params
  })
}

export function getDocHistoryInfo(dhId) {
  return request({
    url: `/dms/docHistory/info/${dhId}`,
    method: 'post'
  })
}

export function restoreDocHistory(dhId) {
  return request({
    url: `/dms/docHistory/restore/${dhId}`,
    method: 'post'
  })
}

export function getDeleteDocPage(params) {
  return request({
    url: '/dms/doc/delete/page',
    method: 'get',
    params
  })
}
